import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import advancedFormat from 'dayjs/plugin/advancedFormat';
import { DEFAULT_DATE_FORMAT, DEFAULT_DATE_TIME_FORMAT } from './Constants';

class DateTimeUtils {
  static instance: DateTimeUtils | null = null;

  static getInstance() {
    if (this.instance == null) this.instance = new DateTimeUtils();

    return this.instance;
  }

  constructor() {
    dayjs.extend(utc);
    dayjs.extend(timezone);
    dayjs.extend(advancedFormat);
  }

  getCurrentUTCDateTime = () => {
    return dayjs.utc().format();
  };

  // formatToUTC = (date: string | number | Date | dayjs.Dayjs) => {
  //   return dayjs.utc(date).format();
  // };

  formatToUTC = (
    date: string | number | Date | dayjs.Dayjs,
    keepLocalTime?: boolean | undefined,
  ) => {
    return dayjs(date).utc(keepLocalTime).format('YYYY-MM-DDTHH:mm:ss');
  };

  isBefore = (
    date: string | number | Date | dayjs.Dayjs,
    compareToDate: string | number | Date | dayjs.Dayjs,
    unit?: dayjs.OpUnitType,
  ) => {
    return dayjs(date).isBefore(compareToDate, unit);
  };

  isAfter = (
    date: string | number | Date | dayjs.Dayjs,
    compareToDate: string | number | Date | dayjs.Dayjs,
    unit?: dayjs.OpUnitType,
  ) => {
    return dayjs(date).isAfter(compareToDate, unit);
  };

  formatYear = (year?: number) => {
    if (year == null || year < 1) return 'Less than a year';
    if (year === 1) return '1 year';
    return `${year} years`;
  };

  formatDate = (
    date: string | number | Date | undefined | null | dayjs.Dayjs,
    template: string = DEFAULT_DATE_FORMAT,
  ) => {
    return dayjs(date).format(template);
  };

  formatDateTime = (
    date: string | number | Date | undefined | dayjs.Dayjs,
    template: string = DEFAULT_DATE_TIME_FORMAT,
  ) => {
    return dayjs(date).format(template);
  };

  formatDateUK = (
    date: string | number | Date | undefined | null | dayjs.Dayjs,
    template: string = DEFAULT_DATE_FORMAT,
  ) => {
    if (!date) return '';
    return dayjs(date).tz('Europe/London').format(template);
  };

  formatDateTimeUK = (
    date: string | number | Date | undefined | dayjs.Dayjs,
    template: string = DEFAULT_DATE_TIME_FORMAT,
  ) => {
    return dayjs(date).tz('Europe/London').format(template);
  };

  getFromToForLastSomeDays = (days: number) => {
    return {
      from: dayjs().subtract(days, 'day').toDate(),
      to: dayjs().toDate(),
    };
  };

  getFromToForThisMonth = () => {
    return {
      from: dayjs().startOf('month').toDate(),
      to: dayjs().endOf('month').toDate(),
    };
  };

  getFromToForPreviousMonth = () => {
    return {
      from: dayjs().subtract(1, 'month').startOf('month').toDate(),
      to: dayjs().subtract(1, 'month').endOf('month').toDate(),
    };
  };

  daysDiff(date: string | number | Date | undefined | dayjs.Dayjs) {
    return dayjs().diff(date, 'd');
  }
}

const DateUtils = DateTimeUtils.getInstance();

export default DateUtils;
